import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import { useStaffAccess } from '../../hooks/useStaffAccess';
import { RubyLoader } from '../../components/RubyLoader';
import FleetDevicePage from '../pos/device/FleetDevicePage';
import { fleetMonitoringTarget, devicePageTarget, prefersFleetMonitoring } from './fleetAccess';

export { fleetMonitoringTarget, devicePageTarget, prefersFleetMonitoring, isLegacyFleetUrl } from './fleetAccess';

function MovedNotice() {
  return (
    <div className="mb-3 rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-[13px] text-amber-900">
      Fleet has moved to Fleet Monitoring (Deployment &amp; Release). You are seeing the old view because your role does not include
      Fleet Monitoring yet — ask the owner to grant Fleet Monitoring.
    </div>
  );
}

export function LegacyFleetGate({ children }: { children: React.ReactNode }) {
  const access = useStaffAccess();
  const { search } = useLocation();
  if (access.loading) return <RubyLoader variant="section" className="py-12" />;
  if (prefersFleetMonitoring(access)) return <Navigate to={fleetMonitoringTarget(search)} replace />;
  return <><MovedNotice />{children}</>;
}

export function LegacyDeviceRoute() {
  const access = useStaffAccess();
  const { deviceId = '' } = useParams<{ deviceId: string }>();
  const { search } = useLocation();
  if (access.loading) return <RubyLoader variant="page" />;
  if (prefersFleetMonitoring(access)) return <Navigate to={devicePageTarget(deviceId, search)} replace />;
  return <FleetDevicePage />;
}
